export default __webpack_public_path__ + "static/media/SharePizza_05.bf6e66f7.png";